import React from "react";
import { VictoryAxis, VictoryBar, VictoryChart, VictoryTheme } from "victory";
import { ChartBarModel } from "../../model/chart/ChartBarModel";


type ChartProps = {

    width: number | undefined;
    height: number | undefined;
    data: ChartBarModel;
    colorFunction?: (datum: any) => string;
};

export default function ChartBarHorizontal(props: ChartProps) {

    return (
        <div>
            <p style={{ fontSize: 18, fontWeight: 500, color: "#777", marginLeft: 20, marginTop:10, paddingTop: 10 }}>{props.data.title}</p>

            <VictoryChart
                theme={VictoryTheme.material}
                domainPadding={20}
                width={props.width}
                height={props.height}
                padding={{ top: 10, bottom: 30, left: 160, right: 50 }}
                
            >
                <VictoryAxis
                    tickValues={props.data.bars.map((item, index) => index + 1)}
                    tickFormat={props.data.bars.map((item, index) => item.name)}
                />
                <VictoryAxis
                    dependentAxis
                    tickValues={[2, 4, 6, 8, 10]}
                    tickFormat={(x) => (`${x}`)}
                />
                <VictoryBar horizontal
                    data={props.data.bars}
                    barRatio={0.2}
                    style={{
                        data: {
                            fill: props.colorFunction
                        }
                    }}
                    x={"name"}
                    y={"y"}
                    labels={({ datum }) => `${datum.y}`}
                />
            </VictoryChart>
        </div>

    )
}